import { render } from "./IconChevronRightTiny.vue?vue&type=template&id=ee800420"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronRightTiny.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee800420"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee800420', __exports__)) {
    api.reload('ee800420', __exports__)
  }
  
  module.hot.accept("./IconChevronRightTiny.vue?vue&type=template&id=ee800420", () => {
    api.rerender('ee800420', render)
  })

}


export default __exports__